// Usa el mismo storage configurado en redux-persist
import storage from 'redux-persist/lib/storage';
import { store, persistor } from '../app/store/store';

async function purgeReducers(reducerKeys = [], options = { }) {
  try {
    // 1️⃣ Borra solo los reducers especificados
    await Promise.all(
      reducerKeys.map(async (key) => {
        await storage.removeItem(`persist:${key}`);
      })
    );
    // await persistor.flush(); // Limpia la cola de persistencia
    //await persistor.pause(); // Detiene la persistencia temporalmente
    reducerKeys.forEach((key) => {
      store.dispatch({ type: `RESET_${key.toUpperCase()}_STATE`, payload: { ...options } });
    });

    // Reactiva la persistencia con los cambios
    await persistor.flush();
    console.log(`Reducers eliminados: ${reducerKeys.join(', ')} 🚀`);
  } catch (error) {
    console.error('Error al purgar la persistencia:', error);
  }
}

export default purgeReducers;
